import Services from './index';
import { OFFER_URL, OFFER_CAMPAIGN_URL } from 'consts/api';

class OfferServices {
  create(body) {
    return Services.post(OFFER_URL, {
      action: 'create',
      ...body,
    });
  }

  getList(body = { offset: 0, title: '', url: '', limit: 20 }) {
    return Services.post(OFFER_URL, {
      action: 'getByUserId',
      ...body,
    });
  }

  getById({ id, userId }) {
    return Services.post(OFFER_URL, {
      action: 'read',
      id,
      userId,
    });
  }

  update(body) {
    return Services.post(OFFER_URL, {
      action: 'update',
      ...body,
    });
  }

  delete({ id, userId }) {
    return Services.post(OFFER_URL, {
      action: 'delete',
      id,
      userId,
    });
  }

  updateOfferCampaign({ id, userId, status }) {
    return Services.post(OFFER_CAMPAIGN_URL, {
      action: 'update',
      id,
      userId,
      status,
    });
  }

  updateDomainCampaign({ id, status }) {
    return Services.post(OFFER_CAMPAIGN_URL, {
      action: 'togger-domain',
      id,
      status,
    });
  }
}

export default new OfferServices();
